import { showSuccessNotification } from '../../../../../component/notification';

export const copyToClipboard = async (
  voucherCode: string,
  successMsg: string = 'Voucher code copied successfully',
): Promise<void> => {
  if (!voucherCode) return;

  try {
    await navigator.clipboard.writeText(voucherCode);
    showSuccessNotification(successMsg);
  } catch (error) {
    console.error('Copy error:', error);
  }
};
